import React, { Component, useState } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Modal } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/accounting/coa4/form";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import { typeCoa4 } from "../../../utilities/Const/TranscationCode";
import TableCOA4 from "./table";
const MySwal = withReactContent(Swal);
export class Coa4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      titleModal: "",
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Accounting"), class: " text-gray-600" },
        { link: null, title: i18n.t("COA 4"), class: " text-gray-500" },
      ],
      column: [
        {
          key: "parent",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("COA 3"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "code",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("ID COA 4"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "name",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        // {
        //   key: "status",
        //   filter: {
        //     active: true,
        //     type: "Select",
        //     data: transactionCodePO,
        //   },
        //   title: i18n.t("Status"),
        //   type: "component",
        //   tHclass: "min-w-125px",
        //   tdClass: "",
        //   component: (data, column) => {
        //     return <LabelTranscation value={data[column.key]} />;
        //   },
        // },
        {
          key: "item_type",
          filter: {
                active: true,
                type: "Select",
                data: typeCoa4,
              },
          title: i18n.t("Type Item"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
          translate:true,
          // component: (data, column) => {
          //       return <LabelTranscation value={data[column.key]} />;
          //     },
        },
        // {
        //   key: "item_id",
        //   filter: { active: false, type: "Text", data: null },
        //   title: i18n.t("ID Item"),
        //   type: "text",
        //   tHclass: "min-w-120px",
        //   tdClass: "",
        // },
        {
          key: "dateCutOff_format",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Date Cut Off"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "beginning_balance_format",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Balance"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.createData = this.createData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.titleModal = i18n.t("Add Coa4");
    this.props.createData();
  }
  updateData(id) {
    this.state.titleModal = i18n.t("Edit Coa4");
    this.props.updateItem(id);
  }
  deleteData(id) {
    const html = (
      <>
        <div>{i18n.t("You will delete this Item")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.deleteItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Deleting Data"),
              html: i18n.t("Please Wait ...."),
              icon: i18n.t("info"),
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Delete")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: i18n.t("question"),
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  render() {
    const { isProcessing, data, showModal } = this.props;
    this.state.listData = data;
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <TableCOA4
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  deleteData={this.deleteData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
      </div>
    );
  }
}

export default Coa4;
